import React from 'react'
import "./Tour_Banner.css"

const Tour_Banner = () => {
    return (
        <section className='Tour_Banner About_Banner'>
            <div className='container-fluid'>
                <div className='About_Banner_holder'>
                    <h5 className='about_us'>Tour Packages</h5>
                </div>
            </div>
        </section>
    )
}

export default Tour_Banner